/** Same as App.css `html` + meta theme-color — Safari status bar uses this. */
export const LOGIN_SURFACE = "#0D233F";
export const APP_THEME_COLOR = "#0D233F";

function setThemeColor(color: string) {
    const existing = document.querySelector('meta[name="theme-color"]');
    // Never remove/recreate the meta — Safari flashes the top bar when the node is replaced.
    if (existing) {
        if (existing.getAttribute("content") !== color) {
            existing.setAttribute("content", color);
        }
        return;
    }
    const meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    meta.setAttribute("content", color);
    document.head.appendChild(meta);
}

/** Reinforce brand navy on login (idempotent — no flash if already set). */
export function applyLoginChrome() {
    if (typeof document === "undefined") return;
    setThemeColor(LOGIN_SURFACE);
    document.documentElement.style.setProperty("background-color", LOGIN_SURFACE, "important");
    document.body.style.setProperty("background-color", LOGIN_SURFACE, "important");
    document.getElementById("root")?.style.setProperty("background-color", LOGIN_SURFACE, "important");
}

export function clearLoginChrome() {
    if (typeof document === "undefined") return;
    // Keep theme-color on brand navy; only drop inline overrides so in-app body styles apply.
    setThemeColor(APP_THEME_COLOR);
    document.documentElement.style.removeProperty("background-color");
    document.body.style.removeProperty("background-color");
    document.getElementById("root")?.style.removeProperty("background-color");
}
